module.exports = __webpack_public_path__ + "img/anguished.aac29f8e.png";